import React from "react";
import { Grid } from "@mui/material";
import LabeledText from "../../../Widgets/LabeledText";
import {
  CurrentCommunicationFormValues,
  COMMUNICATION_MODALITY_OPTIONS,
  COMMUNICATION_PROFICIENCY_OPTIONS,
  COMMUNICATION_FUNCTION_LEVEL_OPTIONS,
  getLabelForValue,
} from "./interface";

interface ViewFieldsProps {
  formValues: CurrentCommunicationFormValues;
}

export const ViewFields: React.FC<ViewFieldsProps> = ({ formValues }) => {
  return (
    <Grid container sx={{ rowGap: "24px" }}>
      <LabeledText
        label="Primary Communication Modality"
        value={getLabelForValue(COMMUNICATION_MODALITY_OPTIONS, formValues.primaryCommunicationModality)}
      />
      <LabeledText
        label="Communication Proficiency"
        value={getLabelForValue(COMMUNICATION_PROFICIENCY_OPTIONS, formValues.communicationProficiency)}
      />
      <LabeledText
        label="Communication Function Level"
        value={getLabelForValue(COMMUNICATION_FUNCTION_LEVEL_OPTIONS, formValues.communicationFunctionLevel)}
      />
    </Grid>
  );
};

export default ViewFields;
